/* global jQuery MktoForms2 anime:false */
jQuery(document).ready(function ($) {
    $(".q-accordion button").click(function(){
        var $answer = $(this).closest(".q-accordion").next(".q-answer");
        $answer.toggleClass("hidden open");

        // Toggle the visibility of the SVG icons
		$(this).find("svg").toggle();
    });
});

(function ($, MktoForms2) {
	"use strict";
	MktoForms2.onFormRender(function () {
		setTimeout(function(){
			$(".mktoButtonWrap button[type=submit]").text("Learn More Now");
		}, 5);
	});
}(jQuery, MktoForms2));

document.addEventListener("DOMContentLoaded", function() {
	const getDemoButton = document.getElementById("get-demo-button");
	const heroSection = document.getElementById("request-demo");

	window.addEventListener("scroll", function() {
	  const heroBottom = heroSection.getBoundingClientRect().bottom;
	  if (heroBottom < 0) {
		getDemoButton.classList.add("visible");
	  } else {
		getDemoButton.classList.remove("visible");
	  }
	});

	getDemoButton.addEventListener("click", function() {
	  window.scrollTo({ top: 0, behavior: "smooth" });
	});
});

(function () {
	"use strict";

	const heroSlide1 = document.querySelector(".js-hero-screen1");
	const heroSlide2 = document.querySelector(".js-hero-screen2");

	anime({
		targets: ".js-hero-screen1 .str",
		opacity: [0, 1],
		duration: 3200,
		easing: "easeOutQuint",
		delay: anime.stagger(1500),
		complete: function() {
			setTimeout(playSlide2, 2500);  // Delay 2.5 seconds, then restart from Slide 1
		}
	});

	window.addEventListener('load', function() {
		anime({
			targets: ".js-form-anime",
			opacity: [0, 1],
			duration: 1200,
			easing: "easeOutQuint",
			delay: 1800
		});
	});

	// Define animation for heroSlide1
	function playSlide1() {
		anime({
			targets: ".js-hero-screen2",
			opacity: [1, 0],
			easing: "easeInQuad",
			duration: 1200,
			begin: function() {
				heroSlide1.style.opacity = "1";
			},
			complete: function() {
				heroSlide2.classList.add("hidden");
				heroSlide1.classList.remove("hidden");
				anime({
					targets: ".js-hero-screen1 .str",
					opacity: [0, 1],
					duration: 3200,
					easing: "easeOutQuint",
					delay: anime.stagger(1500),
					complete: function() {
						setTimeout(playSlide2, 2500);  // Delay 2.5 seconds, then restart from Slide 2
					}
				});
			}
		});
	}

	// Define animation for heroSlide2
	function playSlide2() {
		anime({
			targets: ".js-hero-screen1",
			opacity: [1, 0],
			easing: "easeInQuad",
			duration: 1200,
			begin: function() {
				heroSlide2.style.opacity = "1";
			},
			complete: function() {
				heroSlide1.classList.add("hidden");
				heroSlide2.classList.remove("hidden");
				anime({
					targets: ".js-hero-screen2 .str",
					opacity: [0, 1],
					duration: 3200,
					easing: "easeOutQuint",
					delay: anime.stagger(1500),
					complete: function() {
						playSlide1();
					}
				});
			}
		});
	}

})();